import React from "react";
import "./index.scss";
import { randomColor } from "../../../actions";
import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { GOButton, GOLabel } from "../../../components";
import {
  actionDeleteUserTicket,
  actionPutUserTicketExtendLessonPeriod
} from "../../../stores/actions";
import { toast } from "react-toastify";

dayjs.extend(isBetween);

const dynamicState = (TICKET: any) => {
  switch (TICKET && TICKET.status) {
    case 2:
      return {
        className: "payment_panel payment_refund",
        status: "refund"
      };
    case 3:
      return {
        className: "payment_panel payment_deleted",
        status: "deleted"
      };
    default:
      if (TICKET) {
        if (
          dayjs().diff(dayjs(TICKET.endDate)) > 0 ||
          TICKET.status === 1 ||
          (!TICKET.isUnlimited && TICKET.remainingCount === 0)
        ) {
          if (TICKET.type === 4 && TICKET.status === 0) {
            //락카 배정이 안된 경우
          } else if (
            TICKET.type === 4 &&
            TICKET.status === 1 &&
            dayjs().diff(dayjs(TICKET.endDate)) < 0
          ) {
            return {
              className: "payment_panel payment_panel",
              status: "paid",
              refund: true
            };
          } else {
            return {
              className: "payment_panel payment_expired",
              status: "expired"
            };
          }
        }
      }
      return {
        className: "payment_panel payment_panel",
        status: "paid",
        refund: true
      };
  }
};

const isRemovalLockerTicket = (TICKET: any, nowState: any): boolean => {
  try {
    if (
      nowState.status === "expired" &&
      TICKET.type === 4 &&
      dayjs(TICKET.startDate).isSameOrAfter(dayjs(), "month")
    ) {
      return true;
    }
  } catch (e) {
    return false;
  }
  return false;
};

const isRemovalLessonTicket = (TICKET: any, nowState: any): boolean => {
  try {
    if (
      nowState.status === "expired" &&
      TICKET.type === 0 &&
      TICKET.isUnlimited === false &&
      TICKET.remainingCount > 0 &&
      dayjs(TICKET.endDate)
        .add(1, "month")
        .isSameOrAfter(dayjs(), "month")
    ) {
      return true;
    }
  } catch (e) {
    return false;
  }
  return false;
};

const showExpiredTicketInfo = (nowState: any, TICKET: any, t: any) => {
  try {
    if (
      TICKET.type === 4 &&
      nowState.status === "expired" &&
      dayjs().diff(dayjs(TICKET.endDate)) > 0
    ) {
      return (
        <GOLabel label={t("common.locker")} body={t("ticket.expiredTicket")} />
      );
    } else if (TICKET.type === 4 && nowState.status === "expired") {
      return <></>;
    } else if (nowState.status === "expired") {
      return (
        <GOLabel
          label={t("ticket.expiration")}
          body={t("ticket.expiredTicket")}
        />
      );
    } else {
      return <></>;
    }
  } catch (e) {
    return <GOLabel label={t("common.error")} body={t("common.error")} />;
  }
};

const showLockerInfo = (nowState: any, TICKET: any, t: any) => {
  try {
    let bodyMessage = `-`;
    let bodyStyle = { color: "black", fontWeight: "bold" };

    if (TICKET.status === 0) {
      // bodyMessage = `미배정`;
      bodyMessage = `${t("locker.notAssigned")}`;
      bodyStyle = { color: "red", fontWeight: "bold" };
    } else if (TICKET.status === 1 && dayjs().diff(dayjs(TICKET.endDate)) > 0) {
      bodyMessage = `-`;
      bodyStyle = { color: "black", fontWeight: "regular" };
    } else if (TICKET.status === 1) {
      bodyMessage = `${t("locker.assigned")}`;
      bodyStyle = { color: "black", fontWeight: "bold" };
    } else {
      bodyMessage = `-`;
      bodyStyle = { color: "black", fontWeight: "regular" };
    }
    return (
      <GOLabel
        label={t("common.locker")}
        body={bodyMessage}
        bodyStyle={bodyStyle}
      />
    );
  } catch (e) {
    return <GOLabel label={t("common.locker")} body={`-`} />;
  }
};

const PaymentPanel = ({
  data,
  setUnPaid,
  setRefund,
  setEdit,
  doUpdate
}: any) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const TICKET = data.ticket;
  const PRODUCT = data.ticket && data.ticket.Product;
  // console.log(TICKET)

  const nowState = dynamicState(TICKET);

  const isRemovalExpiredLockerTicket = isRemovalLockerTicket(TICKET, nowState);
  const isRemovalExpiredLessonTicket = isRemovalLessonTicket(TICKET, nowState);

  // if (TICKET.type === 4) {
  //   console.log(TICKET.name + '  ' + TICKET.startDate + ' ' + isRemovalExpiredLockerTicket);
  // }

  const startMonth = dayjs()
    .startOf("month")
    .format("YYYY-MM-DDT00:00:00");
  const endMonth = dayjs()
    .endOf("month")
    .format("YYYY-MM-DDT23:59:59");

  const onDelete = () => {
    // if (window.confirm("결제내역을 삭제하시겠습니까?")) {
    if (window.confirm(t("ticket.confirmDeletePayment"))) {
      dispatch(
        actionDeleteUserTicket(TICKET.id, () => {
          // alert("삭제 되었습니다.");
          alert(t("ticket.deleteSuccess"));
          doUpdate();
        })
      );
    }
  };

  const onExtendPeriod = () => {
    if (window.confirm(t("ticket.confirmExtendPeriod)"))) {
      dispatch(
        actionPutUserTicketExtendLessonPeriod(
          TICKET.id,
          () => {
            alert(t("user.extendSuccess"));
            doUpdate();
          },
          (err: any) => {
            toast.error(t("user.failedToExtendPeriod"));
          }
        )
      );
    }
  };

  const onEdit = () => {
    setEdit(data);
  };

  return (
    <div className={nowState.className}>
      {TICKET ? (
        <>
          <div
            className="Panel_circle"
            style={{
              background:
                PRODUCT.ProductCategory && PRODUCT.ProductCategory.id === null
                  ? ""
                  : randomColor(
                      PRODUCT.ProductCategory && PRODUCT.ProductCategory.id
                    )
            }}
          />{" "}
          {nowState.status === "refund" && `( ${t("user.refund")} )`}{" "}
          <span>{PRODUCT.ProductCategory && PRODUCT.ProductCategory.name}</span>
          {/*{nowState.status === 'paid' && dayjs(TICKET.paymentDate).isBetween(startMonth, endMonth) && (*/}
          {nowState.status === "paid" &&
            dayjs(data.paymentDate).isBetween(startMonth, endMonth) && (
              <>
                <div className="payment_delete_icon" onClick={onDelete}>
                  {t("common.del")}
                </div>
                <div className="payment_edit_icon" onClick={onEdit}>
                  {t("common.edit")}
                </div>
              </>
            )}
          {isRemovalExpiredLockerTicket && (
            <>
              <div className="payment_delete_icon" onClick={onDelete}>
                {t("common.del")}
              </div>
            </>
          )}
          {isRemovalExpiredLessonTicket && (
            <>
              <div className="payment_delete_icon" onClick={onExtendPeriod}>
                {t("user.extendPeriod")}
              </div>
            </>
          )}
          <h4>{PRODUCT.name}</h4>
          <GOLabel
            label={t("user.buyDate")}
            body={dayjs(data.paymentDate).format("YY. MM. DD / HH:mm:ss")}
          />
          <GOLabel
            label={t("common.period")}
            body={`${dayjs(TICKET.startDate).format("YY. MM. DD")} ~ ${dayjs(
              TICKET.endDate
            ).format("YY. MM. DD")}`}
          />
          {TICKET.type === 4 ? (
            showLockerInfo(nowState, TICKET, t)
          ) : (
            <GOLabel
              label={t("user.remainingCount")}
              body={
                TICKET.isUnlimited
                  ? `${t("ticket.unlimited")}`
                  : `${t("ticket.leftCount")}: ${TICKET.remainingCount}  ${t(
                      "ticket.totalCount"
                    )} ${TICKET.totalCount}`
              }
            />
          )}
          <hr />
          <GOLabel
            label={t("ticket.originalPrice")}
            body={`${TICKET.originalPrice.toLocaleString("en")} ${t(
              "common.KRW"
            )}`}
          />
          <GOLabel
            label={t("ticket.discountPrice")}
            body={`${TICKET.discount.toLocaleString("en")} ${t("common.KRW")}`}
          />
          <hr />
          <GOLabel
            label={t("ticket.paidPrice")}
            body={
              <>
                {(TICKET.price - data.unpaidPrice).toLocaleString("en")}{" "}
                {t("common.KRW")}
              </>
            }
          />
          {showExpiredTicketInfo(nowState, TICKET, t)}
          <span className="red">
            {data.unpaidPrice ? (
              <GOLabel
                label={t("ticket.unpaid")}
                body={`${data.unpaidPrice.toLocaleString("en")} ${t(
                  "common.KRW"
                )}`}
              />
            ) : (
              <></>
            )}
            {nowState.status === "refund" && (
              // <GOLabel label="환불" body={`환불 처리 됨`} />
              <GOLabel
                label={t("ticket.refund")}
                body={`${t("ticket.refunded")}`}
              />
            )}
            {nowState.status === "deleted" && (
              // <GOLabel label="삭제" body={`삭제된 결제내역`} />
              <GOLabel
                label={t("ticket.delete")}
                body={`${t("ticket.deletedPayment")}`}
              />
            )}
          </span>
          <div className="center">
            {nowState.status !== "deleted" && data.unpaidPrice ? (
              <GOButton
                buttontype="red"
                body={t("ticket.settlementOfUnpaid")}
                onClick={() => {
                  setUnPaid(data);
                }}
                noMarginLeft
              />
            ) : (
              ""
            )}
            {nowState.refund && (
              <GOButton
                body={t("ticket.refund")}
                noMarginLeft
                onClick={() => {
                  setRefund(data);
                }}
              />
            )}
          </div>
        </>
      ) : (
        <>
          <GOLabel
            label={t("product.title")}
            body={`${t("product.deleteProduct")}`}
          />
          <span className="red">
            {data.unpaidPrice ? (
              <GOLabel
                label={t("ticket.unpaid")}
                body={`${data.unpaidPrice.toLocaleString("en")} ${t(
                  "common.KRW"
                )}`}
              />
            ) : (
              <></>
            )}
            {data.status === 2 && (
              <GOLabel
                label={t("ticket.refund")}
                body={`${t("ticket.refunded")}`}
              />
            )}
          </span>
        </>
      )}
    </div>
  );
};

export default PaymentPanel;
